import { ReactNode } from 'react'

import { AstraSkeletonLoader, astraTwMerge } from '~/astra'

import { FieldGroupWrapper, FormContentWrapper } from './FormWrapper'

const SkeletonField = ({ className }: { className?: string }) => (
    <div className={astraTwMerge('flex flex-col gap-1', className)}>
        <div className="h-4 w-20">
            <AstraSkeletonLoader />
        </div>
        <div className="h-10 w-full">
            <AstraSkeletonLoader />
        </div>
    </div>
)

export const FormSkeleton = ({ title }: { title?: ReactNode }) => (
    <FormContentWrapper title={title ?? <AstraSkeletonLoader />}>
        <div className="flex flex-col gap-6">
            <FieldGroupWrapper>
                <SkeletonField />
                <SkeletonField />
            </FieldGroupWrapper>

            <FieldGroupWrapper>
                <SkeletonField />
                <SkeletonField />
            </FieldGroupWrapper>

            <div className="flex flex-col gap-4">
                <div className="h-6 w-32">
                    <AstraSkeletonLoader />
                </div>
                <div className="flex items-start justify-around gap-4 pl-6 md:pl-[40px]">
                    <FieldGroupWrapper className="flex-1">
                        <SkeletonField />
                        <SkeletonField />
                    </FieldGroupWrapper>
                    <div className="h-10 w-10 shrink-0 pt-5">
                        <AstraSkeletonLoader />
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-4">
                <div className="h-6 w-48">
                    <AstraSkeletonLoader />
                </div>
                <div className="flex flex-col gap-3">
                    <div className="h-24 w-full rounded-lg">
                        <AstraSkeletonLoader />
                    </div>
                    <div className="h-24 w-full rounded-lg">
                        <AstraSkeletonLoader />
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between gap-4">
                    <div className="h-6 w-52">
                        <AstraSkeletonLoader />
                    </div>
                    <div className="h-10 w-10 shrink-0">
                        <AstraSkeletonLoader />
                    </div>
                </div>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4 rounded-lg bg-surface-strong p-4">
                        <div className="flex w-full gap-4">
                            <SkeletonField className="flex-1" />
                            <div className="h-10 w-10 shrink-0" />
                        </div>
                        <div className="h-20 w-full rounded-lg">
                            <AstraSkeletonLoader />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="flex justify-end pt-4">
            <div className="h-10 w-24">
                <AstraSkeletonLoader />
            </div>
        </div>
    </FormContentWrapper>
)
